import propTypes from "prop-types";
import React from "react";
import { SpinnerCircular } from "spinners-react";

function executeAllFunctions(functionsArray) {
  functionsArray && functionsArray.forEach((func) => func());
}

function ModalButton({ modalButtonValue, modalButtonFunctions, isLoading }) {
  const handleClick = () => {
    executeAllFunctions(modalButtonFunctions);
  };
  return (
    <button
      disabled={isLoading}
      onClick={handleClick}
      type="button"
      className="w-full flex-1 p-3 text-base font-ibm font-medium text-secondary-100  border border-transparent rounded-2xl bg-[#00ABFB] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
    >
      {isLoading ? (
        <SpinnerCircular
          size={20}
          thickness={100}
          speed={100}
          color="#00ABFB"
          secondaryColor="#f3f4f6"
          className="mx-auto"
        />
      ) : (
        modalButtonValue
      )}
    </button>
  );
}

ModalButton.propTypes = {
  modalButtonValue: propTypes.string,
  modalButtonFunctions: propTypes.array,
  isLoading: propTypes.bool,
};

export default ModalButton;
